/* eslint-disable import/prefer-default-export */
export enum SkillsPathLandingTab {
  Overview = 'overview',
  Offerings = 'offerings',
}
